const dev = {
  // Someone changed this on production outside of git. Not sure why. Leaving it as is, but adding the old version back commented out.
  // API_URL: 'https://staging.admin.citizenmusic.com/wp-json',
  API_URL: 'https://admin.citizenmusic.com/wp-json',
};

const prod = {
  API_URL: 'https://admin.citizenmusic.com/wp-json',
};

const config = process.env.REACT_APP_STAGE === 'production'
  ? prod
  : dev;

export default config;


// WEBPACK FOOTER //
// ./src/config.js